import React from 'react';

function Logo(props) {
  return <img alt="Logo" src="/static/images/Logo-NoSubTitle-InnerAdmin@3x.png" {...props} />;
}

export default Logo;
